import intermind, { BillingCycle } from '../../index';
import { InvoiceResource } from './resources/invoice';
import { PaymentResource } from './resources/payment';
import { PlanResource } from './resources/plan';
import { QuotaResource } from './resources/quota';
import { SubscriptionResource } from './resources/subscription';

export class BillingResource {
  private readonly planResource: PlanResource;
  private readonly quotaResource: QuotaResource;
  private readonly subscriptionResource: SubscriptionResource;
  private readonly invoiceResource: InvoiceResource;
  private readonly paymentResource: PaymentResource;

  constructor() {
    this.planResource = new PlanResource();
    this.quotaResource = new QuotaResource();
    this.subscriptionResource = new SubscriptionResource();
    this.invoiceResource = new InvoiceResource();
    this.paymentResource = new PaymentResource();
  }

  get plan() {
    return this.planResource;
  }

  get quota() {
    return this.quotaResource;
  }

  get subscription() {
    return this.subscriptionResource;
  }

  get invoice() {
    return this.invoiceResource;
  }

  get payment() {
    return this.paymentResource;
  }

  async checkout(planCode: string, billingCycle: BillingCycle): Promise<string> {
    const { data } = await intermind.httpClient.get<string>(
      `/billing/checkout?planCode=${planCode}&billingCycle=${billingCycle}`
    );
    return data;
  }
}
